var map = {
	"./ellipse.png": 3260,
	"./rect1.png": 4473,
	"./rect2.png": 3762,
	"./rect3.png": 7979,
	"./rect4.png": 6324,
	"./rect5.png": 8650,
	"./rect6.png": 4646,
	"./rect7.png": 975,
	"./star.png": 9372,
	"./store1.png": 6088,
	"./store2.png": 2947,
	"./store3.png": 1370,
	"./store4.png": 5669,
	"./store5.png": 2780,
	"./store6.png": 1255,
	"./store7.png": 9918,
	"./store8.png": 8809,
	"./triangle.png": 1152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6987;